import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { useDeleteAdminLocation, useDeleteAdminLocationOption, useUnassignAdminLocationOptionUsers, useUnassignAdminLocationUsers, useUpdateAdminLocation, useUpdateAdminLocationOption, } from '@/api/opengater/useLocations';
import { SettingsAction, SettingsDanger } from '@/components/settings/Settings';
import { locationAdminError, locationObjectAction } from './locationRules';
export function LocationDangerActions({ entity, id, isActive, usersCount, onChanged, onOperation, onDeleted, disabled = false, }) {
    const updateLocation = useUpdateAdminLocation();
    const updateOption = useUpdateAdminLocationOption();
    const unassignLocation = useUnassignAdminLocationUsers();
    const unassignOption = useUnassignAdminLocationOptionUsers();
    const deleteLocation = useDeleteAdminLocation();
    const deleteOption = useDeleteAdminLocationOption();
    const action = locationObjectAction(isActive, usersCount);
    const noun = entity === 'location' ? 'локацию' : 'опцию локации';
    const current = useMemo(() => {
        if (action === 'hide')
            return entity === 'location' ? updateLocation : updateOption;
        if (action === 'unassign')
            return entity === 'location' ? unassignLocation : unassignOption;
        return entity === 'location' ? deleteLocation : deleteOption;
    }, [
        action,
        deleteLocation,
        deleteOption,
        entity,
        unassignLocation,
        unassignOption,
        updateLocation,
        updateOption,
    ]);
    const error = current.error
        ? locationAdminError(current.error, 'Не удалось выполнить действие.')
        : undefined;
    if (action === 'hide') {
        return (_jsx(SettingsAction, { label: `Скрыть ${noun}`, icon: "flag", tone: "danger", confirmText: `Новые пользователи больше не получат эту ${entity === 'location' ? 'локацию' : 'опцию'}. Уже назначенные пользователи останутся на ней.`, confirmLabel: "\u0421\u043A\u0440\u044B\u0442\u044C", pending: current.isPending, disabled: disabled, error: error, onConfirm: async () => {
                try {
                    if (entity === 'location') {
                        await updateLocation.mutateAsync({ id, patch: { is_active: false } });
                    }
                    else {
                        await updateOption.mutateAsync({ id, patch: { is_active: false } });
                    }
                    await onChanged();
                }
                catch {
                    // The mutation exposes its error below the action.
                }
            } }));
    }
    if (action === 'unassign') {
        return (_jsx(SettingsAction, { label: "\u0421\u043D\u044F\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u0435\u0439", icon: "users", tone: "danger", confirmText: `Будут сняты ${usersCount.toLocaleString('ru-RU')} пользователей. Тарифы и доступы пересчитаются в фоне.`, confirmLabel: "\u041D\u0430\u0447\u0430\u0442\u044C \u0441\u043D\u044F\u0442\u0438\u0435", pending: current.isPending, disabled: disabled, error: error, onConfirm: async () => {
                try {
                    const result = entity === 'location'
                        ? await unassignLocation.mutateAsync(id)
                        : await unassignOption.mutateAsync(id);
                    if (result.operation_id === null)
                        await onChanged();
                    onOperation(result.operation_id);
                }
                catch {
                    // The mutation exposes its error below the action.
                }
            } }));
    }
    return (_jsx(SettingsDanger, { label: `Удалить ${noun}`, confirmText: `Удалить ${noun}? Отменить это действие будет нельзя.`, pending: current.isPending, disabled: disabled, error: error, onConfirm: async () => {
            try {
                if (entity === 'location')
                    await deleteLocation.mutateAsync(id);
                else
                    await deleteOption.mutateAsync(id);
                onDeleted();
            }
            catch {
                // The mutation exposes its error below the action.
            }
        } }));
}
